// Compact "Details · Excel · PDF · CSV" bar for one report section. Reuses ExportTrio (same rows → Excel/PDF/CSV)
// and the existing pages/drill-downs for Details. Figures come from the report response only (no recalculation).
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { ExportTrio } from '@/components/accounting/ExportTrio';

export const amountCols = [{ key: 'item', label: 'Item' }, { key: 'value', label: 'Amount (SR)', numeric: true, format: (v) => Number(v || 0).toFixed(2) }];

// Existing list pages accept start_date / end_date / branch.
export const pageLink = (path, { start, end, branchId } = {}) => {
  const q = new URLSearchParams();
  if (start) q.set('start_date', start);
  if (end) q.set('end_date', end);
  if (branchId) q.set('branch', branchId);
  return `${path}?${q.toString()}`;
};

export function SectionBar({ testId, spec, detailsTo, onDetails, disabled }) {
  const btn = 'inline-flex items-center gap-1 rounded-full border border-border px-2 py-0.5 text-[10px] hover:bg-muted transition-colors';
  return (
    <span className="inline-flex items-center gap-1" data-testid={testId} onClick={(e) => e.stopPropagation()}>
      {detailsTo && <Link to={detailsTo} className={btn} data-testid={`${testId}-details`}><ExternalLink size={11} />Details</Link>}
      {onDetails && <button type="button" className={btn} onClick={onDetails} data-testid={`${testId}-details`}><ExternalLink size={11} />Details</button>}
      <ExportTrio spec={spec} testId={`${testId}-export`} disabled={disabled} />
    </span>
  );
}
